module.exports = __webpack_public_path__ + "img/homecontrol-zh.90af98cc.png";